import { render, staticRenderFns } from "./BuildingDisplay.vue?vue&type=template&id=08f216a5"
import script from "./BuildingDisplay.vue?vue&type=script&lang=js"
export * from "./BuildingDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports